import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Get the user's local date in YYYY-MM-DD format.
 * Use this for all API calls that need "today's" data to ensure
 * proper daily reset at midnight local time.
 */
export function getLocalDate() {
  return new Date().toLocaleDateString('en-CA'); // Returns YYYY-MM-DD
}

/**
 * Get the user's local date for a specific date object
 */
export function formatLocalDate(date) {
  return new Date(date).toLocaleDateString('en-CA');
}
